import { Wording } from '@/types';

export const COOKING_WORDING_EE: Wording = {
  components_header_media_content: 'Kokandusvideod',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Retseptid',
  components_header_text2: 'Blogi',
  components_header_members: 'Liikmed',
  hero_text: 'Küpseta kirega, söö rõõmuga',
  hero_button_text: 'Alusta kokkamist juba täna',
  components_ressources_section_title: 'RESSURSID',
  components_ressources_subheader_text: 'Kõik ressursid, mida vajate õppimiseks, toiduvalmistamiseks ja parema toidu loomiseks',
  components_ressources_span_text: 'Avastage rikkalik videoretseptide kogu, üksikasjalikke kokandusjuhendeid ja ekspertide nõuandeid maitsete sobitamise, toidu esitlemise ja kulinaarse loovuse kohta.',
  components_ressources_card_1_title: 'Kokandusinspiratsioon',
  components_ressources_card_1_text: 'Saage inspiratsiooni loomingulistest retseptidest ja kokandusvideotest.',
  components_ressources_card_2_title: 'Kokkamisalased teadmised',
  components_ressources_card_2_text: 'Õpi selgete ja praktiliste juhendite abil olulisi toiduvalmistamistehnikaid, maitsekombinatsioone ja toidupaaride põhitõdesid.',
  components_ressources_link: 'Vaata videoid',
  components_notes_and_google_title_1: 'Kokandusharidus',
  components_notes_and_google_title_2: 'Igapäevane toiduvalmistamine',
  components_notes_and_google_title_3: 'Järjepidevad kokandusoskused',
  components_review_google_text: 'Arvustused Google\'is',
  media_content_section_title: 'Kokandusvideod',
  media_content_section_subheader_text: 'Avasta retsepte ja samm-sammult kokandusvideoid.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Rohkem videoid',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Juhendid ja artiklid',
  text2_section_button_more: 'Rohkem artikleid',
  components_text1_section_title: 'RETSEPTID',
  components_text1_subheader_text: 'Maitsvad retseptid igapäevaseks toiduvalmistamiseks',
  components_text1_span_text: 'Avastage lihtsaid retsepte, mis on loodud igapäevaste toitude jaoks, selged sammud ja suurepärased tulemused.',
  components_text1_card_1_title: 'Alusta oma päeva õigesti',
  components_text1_card_1_text: 'Lihtsad ja maitsvad retseptid, et alustada oma päeva hõlpsalt ja maitsekalt.',
  components_text1_card_3_title: 'Maitsvad lõunasöögi ideed',
  components_text1_card_3_text: 'Maitsvad lõunasöögiretseptid, mis on kergesti valmistatavad ja täis maitset.',
  components_text1_card_2_title: 'Lohutavad õhtusöögiretseptid',
  components_text1_card_2_text: 'Soojad ja toitvad õhtusöögiretseptid, mis sobivad ideaalselt lõõgastavateks õhtuteks kodus.',
  components_text1_link: 'Vaata kõiki retsepte',
  components_footer_text: 'Õpi paremini kokkama, loo paremat toitu: sinu köök, sinu teekond.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreerimisnumber',
  components_footer_legal: 'Õiguslik',
  components_footer_terms: 'Tingimused',
  components_footer_privacy: 'Privaatsuspoliitika',
  button_load_more: 'Laadi rohkem',
  page_media_1_content_hero_text: 'Avastage lihtsaid kokandusvideoid igale maitsele',
  page_text1_hero_text: 'Retseptid',
  page_text1_section_title: 'Kokandusnipid',
  page_text1_subheader_text: 'Retseptid',
  page_text2_hero_text: 'Meie blogi',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Juhendid ja artiklid',
  enter_email_title: 'Jätkamiseks sisestage oma e-posti aadress',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Sisesta',
  components_login_success_text: 'Sisselogimine õnnestus!',
  components_card_link_media_content: 'Vaata kohe',
  components_card_link_text1_content: 'Vaata retsepti',
  components_card_link_text2_content: 'Vaata artiklit',
};